import { Status } from './types';

export const fetchFriendlyStatus = (status: Status): string => {
	if (status === Status.SCHEDULED_WITH_MAF) return 'Scheduled';
	if (status === Status.LIVE) return 'In progress';
	if (status === Status.COMPLETED) return 'Completed';
	return 'Unknown';
};
